import { v4 as uuidv4 } from 'uuid';

import { sessionStorage } from '../services/storage/storage.service';

const _storeResponseArgs = (vars) => {
  sessionStorage.setItem('oAUTHResponseArgs', JSON.stringify(vars));
};

const _getResponseArgs = () => {
  const responseArgs = sessionStorage.getItem('oAUTHResponseArgs');
  sessionStorage.removeItem('oAUTHResponseArgs');
  if (responseArgs) {
    return JSON.parse(responseArgs);
  } else {
    return {
      codeVar: 'code',
      stateVar: 'state',
      errorVar: 'error',
    };
  }
};

const _generateOAUTHRegex = ({ codeVar, stateVar, errorVar }) => {
  return {
    codeRegex: new RegExp(`${codeVar}=(.*?)(?=&|#|$|\\/)`),
    errorRegex: new RegExp(`${errorVar}=(.*?)(?=&|#|$|\\/)`),
    stateRegex: new RegExp(`${stateVar}=(.*?)(?=&|#|$|\\/)`),
  };
};

export default {
  getDomain: (excludeTrailingSlash = false) =>
    `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}${
      excludeTrailingSlash ? '' : '/'
    }`,

  rectify: () => {
    const { codeVar, stateVar, errorVar } = _getResponseArgs();
    const { codeRegex, errorRegex, stateRegex } = _generateOAUTHRegex({ codeVar, stateVar, errorVar });
    const URI = window.location.href;

    try {
      // Get and check the state
      const uriState = stateRegex.test(URI) && stateRegex.exec(URI)[0].replace(`${stateVar}=`, '');

      if (!uriState) {
        return;
      }

      // Check for a code or error
      const uriCode = codeRegex.test(URI) && codeRegex.exec(URI)[0].replace(`${codeVar}=`, '');
      const uriError = errorRegex.test(URI) && errorRegex.exec(URI)[0].replace(`${errorVar}=`, '');

      if (!uriCode && !uriError) {
        return;
      }

      // Get the integration from local storage
      const integration = sessionStorage.getItem('integration');

      if (!integration) {
        return;
      }

      const { route, state } = JSON.parse(integration);

      if (state !== uriState) {
        return;
      }

      sessionStorage.removeItem('integration');

      // Build the url and redirect
      let redirectUri = `${route}?&state=${uriState}`;
      if (uriCode) {
        redirectUri = `${redirectUri}&code=${uriCode}`;
      }
      if (uriError) {
        redirectUri = `${redirectUri}&error=${uriError}`;
      }

      window.location.href = redirectUri;
    } catch (error) {
      sessionStorage.removeItem('integration');

      window.location.href = `${location.protocol}//${window.location.hostname}${
        location.port ? `:${location.port}` : ''
      }/`;
    }
  },

  /**
   * Auth Code grant request flow
   * Specified here https://tools.ietf.org/html/rfc6749#section-1.3.1
   * OAuth 2.0 flows should use this pattern in getting a code from
   * the user
   * @param {{integrationId?: string, integrationName: string, clientId: string, siteId: string, uri: string, scope?: string}} params
   *   {string} integration_id integration_id, optional default is new
   *   {string} integration_name The name of your integration
   *   {string} client_id Client id provided to you from integration provider
   *   {string} uri The URI of the integration provider
   *   {string} scope scope attribute, optional
   * @param {{codeVar?: string, stateVar?: string, errorVar?: string}} responseArgNames
   *  - third parties response arg names
   * @return undefined - redirects to integration provider login flow
   */
  authCodeGrant: function (
    { integrationId = 'new', integrationName, clientId, siteId, uri, scope = null, excludeTrailingSlash = false },
    { codeVar = 'code', stateVar = 'state', errorVar = 'error' } = {},
  ) {
    const state = uuidv4();
    const domain = this.getDomain(excludeTrailingSlash);

    sessionStorage.setItem(
      'integration',
      JSON.stringify({
        route: `${domain}locations/sites/${siteId}/integrations/${integrationName}/${integrationId}`,
        state: state,
      }),
    );

    let OAuthURI = `${uri}?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(domain)}`;
    OAuthURI += `&state=${state}`;
    (OAuthURI += scope ? `&scope=${scope}` : ''), _storeResponseArgs({ codeVar, stateVar, errorVar });

    window.location = OAuthURI;
  },
};
